import { LogLevel } from '../../types/types';

let logLevel = 4; // default
let prefix = '';
const logLevels = {
    info: 1,
    log: 2,
    warn: 3,
    error: 4,
};

const colors = {
    info: '#26c1db',
    log: '#09f979',
    warn: '#f6b13f',
    error: '#e12046',
};

const standardStyles = 'color: white; font-weight: bold; padding: 2px 10px;';

const logAPIResponseTime = (url: string, time: number) => {
    if (window.NREUM) {
        window.NREUM.addPageAction('API-calls-timing', {
            api_call: url,
            api_response_time: time,
        });
    } else {
        warn('Off-site logging not available.');
    }
};

const error = (...args) => {
    if (logLevel <= 4) {
        console.error(`%c${prefix} error`, `background: ${colors.error};${standardStyles}`, ...args); // eslint-disable-line
        // if New Relic is available, send error
        if (window.NREUM && args && args[0]) {
            window.NREUM.noticeError(args[0]);
        } else {
            warn('Off-site logging not available.');
        }
    }
};

const warn = (...args) => {
    if (logLevel <= 3) {
        console.warn(`%c${prefix} warn`, `background: ${colors.warn};${standardStyles}`, ...args); // eslint-disable-line
    }
};

const log = (...args) => {
    if (logLevel <= 2) {
        console.log(`%c${prefix} log`, `background: ${colors.log};${standardStyles}`, ...args); // eslint-disable-line
    }
};

const info = (...args) => {
    if (logLevel <= 1) {
        console.log(`%c${prefix} info`, `background: ${colors.info};${standardStyles}`, ...args); // eslint-disable-line
    }
};

export const logger = {
    error,
    warn,
    log,
    info,
    logAPIResponseTime,
    setLogLevel: (desiredLogLevel: LogLevel) => {
        if (!logLevels.hasOwnProperty(desiredLogLevel)) {
            throw new Error(`Unknown logLevel '${desiredLogLevel}'`);
        }

        logLevel = logLevels[desiredLogLevel];
        console.log(
            `%c${prefix} log level set to ${desiredLogLevel}`,
            `background: ${colors[desiredLogLevel]};${standardStyles}`,
        );
    },
    setPrefix: (thisPrefix: string) => {
        prefix = thisPrefix;
    },
};
